import axios from 'axios';
import { postData } from '../../services/axiosUtils';

const asListResponse = (data: any) => {
  // Axios error interceptor returns { hasError, httpStatus, errorMessages } as data.
  if (data?.hasError) {
    return {
      hasError: true,
      records: [],
      errorMessages: data.errorMessages ?? ['Hiba történt'],
      httpStatus: data.httpStatus,
    };
  }
  if (Array.isArray(data)) {
    return { hasError: false, records: data, errorMessages: [] };
  }
  if (data?.records) return data;
  return { hasError: false, records: data ? [data] : [], errorMessages: [] };
};

const wrapEntity = (data: any) =>
  data?.hasError !== undefined
    ? data
    : { hasError: false, result: data, errorMessages: [] };

const invitationService = {
  list: (tenantId?: string) =>
    axios
      .get(`/api/invitations/list`, {
        params: tenantId ? { tenantId } : undefined,
      })
      .then((r) => asListResponse(r.data)),
  create: (entity: any) =>
    postData({ url: `/api/invitations/create`, data: entity }).then(wrapEntity),
  preview: (code: string) =>
    axios
      .get(`/api/invitations/preview`, { params: { code } })
      .then((r) => ({ hasError: false, result: r.data, errorMessages: [] as string[] }))
      .catch((err) => ({
        hasError: true,
        result: null,
        errorMessages: [
          err?.response?.data?.message ??
            err?.response?.data ??
            'A meghívó betöltése sikertelen.',
        ].flatMap((x) => (typeof x === 'string' ? [x] : [String(x)])),
      })),
  accept: (payload: {
    code: string;
    password?: string;
    fullName?: string;
  }) =>
    axios
      .post(`/api/invitations/accept`, payload)
      .then((r) => wrapEntity(r.data))
      .catch((err) => ({
        hasError: true,
        result: err?.response?.data ?? null,
        status: err?.response?.status,
        errorMessages: [
          err?.response?.data?.message ??
            (typeof err?.response?.data === 'string'
              ? err.response.data
              : 'A meghívó elfogadása sikertelen.'),
        ].flatMap((x) => (typeof x === 'string' ? [x] : [String(x)])),
      })),
};

export default invitationService;
